import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import hasInterface from '../../../../hasInterface';
import Collection from '../../../../java/util/Collection';
import Coordinate from './Coordinate';
import ArrayList from '../../../../java/util/ArrayList';
var CoordinateList = /*#__PURE__*/function (_ArrayList) {
  _inherits(CoordinateList, _ArrayList);
  function CoordinateList() {
    var _this;
    _classCallCheck(this, CoordinateList);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(CoordinateList).call(this));
    CoordinateList.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(CoordinateList, [{
    key: "getCoordinate",
    value: function getCoordinate(i) {
      return this.get(i);
    }
  }, {
    key: "addAll",
    value: function addAll() {
      if (arguments.length === 2 && typeof arguments[1] === 'boolean' && hasInterface(arguments[0], Collection)) {
        var coll = arguments[0],
          allowRepeated = arguments[1];
        var isChanged = false;
        for (var i = coll.iterator(); i.hasNext();) {
          this.add(i.next(), allowRepeated);
          isChanged = true;
        }
        return isChanged;
      } else {
        return _get(_getPrototypeOf(CoordinateList.prototype), "addAll", this).apply(this, arguments);
      }
    }
  }, {
    key: "clone",
    value: function clone() {
      var clone = _get(_getPrototypeOf(CoordinateList.prototype), "clone", this).call(this);
      for (var i = 0; i < this.size(); i++) clone.add(i, this.get(i).clone());
      return clone;
    }
  }, {
    key: "toCoordinateArray",
    value: function toCoordinateArray() {
      if (arguments.length === 0) {
        return this.toArray(CoordinateList.coordArrayType);
      } else if (arguments.length === 1) {
        var isForward = arguments[0];
        if (isForward) return this.toArray(CoordinateList.coordArrayType);
        var size = this.size();
        var pts = new Array(size).fill(null);
        for (var i = 0; i < size; i++) pts[i] = this.get(size - i - 1);
        return pts;
      }
    }
  }, {
    key: "add",
    value: function add() {
      if (arguments.length === 1) {
        var coord = arguments[0];
        return _get(_getPrototypeOf(CoordinateList.prototype), "add", this).call(this, coord);
      } else if (arguments.length === 2) {
        if (arguments[0] instanceof Array && typeof arguments[1] === 'boolean') {
          var _coord = arguments[0],
            allowRepeated = arguments[1];
          this.add(_coord, allowRepeated, true);
          return true;
        } else if (arguments[0] instanceof Coordinate && typeof arguments[1] === 'boolean') {
          var _coord2 = arguments[0],
            _allowRepeated = arguments[1];
          if (!_allowRepeated) if (this.size() >= 1) {
            var last = this.get(this.size() - 1);
            if (last.equals2D(_coord2)) return null;
          }
          _get(_getPrototypeOf(CoordinateList.prototype), "add", this).call(this, _coord2);
        } else if (arguments[0] instanceof Object && typeof arguments[1] === 'boolean') {
          var obj = arguments[0],
            _allowRepeated2 = arguments[1];
          this.add(obj, _allowRepeated2);
          return true;
        }
      } else if (arguments.length === 3) {
        if (typeof arguments[2] === 'boolean' && arguments[0] instanceof Array && typeof arguments[1] === 'boolean') {
          var _coord3 = arguments[0],
            _allowRepeated3 = arguments[1],
            direction = arguments[2];
          if (direction) for (var i = 0; i < _coord3.length; i++) this.add(_coord3[i], _allowRepeated3);else for (var _i = _coord3.length - 1; _i >= 0; _i--) this.add(_coord3[_i], _allowRepeated3);
          return true;
        } else if (typeof arguments[2] === 'boolean' && Number.isInteger(arguments[0]) && arguments[1] instanceof Coordinate) {
          var _i2 = arguments[0],
            _coord4 = arguments[1],
            _allowRepeated4 = arguments[2];
          if (!_allowRepeated4) {
            var size = this.size();
            if (size > 0) {
              if (_i2 > 0) {
                var prev = this.get(_i2 - 1);
                if (prev.equals2D(_coord4)) return null;
              }
              if (_i2 < size) {
                var next = this.get(_i2);
                if (next.equals2D(_coord4)) return null;
              }
            }
          }
          _get(_getPrototypeOf(CoordinateList.prototype), "add", this).call(this, _i2, _coord4);
        }
      } else if (arguments.length === 4) {
        var _coord5 = arguments[0],
          _allowRepeated5 = arguments[1],
          start = arguments[2],
          end = arguments[3];
        var inc = 1;
        if (start > end) inc = -1;
        for (var _i3 = start; _i3 !== end; _i3 += inc) this.add(_coord5[_i3], _allowRepeated5);
        return true;
      }
    }
  }, {
    key: "closeRing",
    value: function closeRing() {
      if (this.size() > 0) {
        var duplicate = this.get(0).copy();
        this.add(duplicate, false);
      }
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      if (arguments.length === 0) {} else if (arguments.length === 1) {
        var coord = arguments[0];
        this.ensureCapacity(coord.length);
        this.add(coord, true);
      } else if (arguments.length === 2) {
        var _coord6 = arguments[0],
          allowRepeated = arguments[1];
        this.ensureCapacity(_coord6.length);
        this.add(_coord6, allowRepeated);
      }
    }
  }]);
  return CoordinateList;
}(ArrayList);
export { CoordinateList as default };
CoordinateList.coordArrayType = new Array(0).fill(null);